import React, { useState } from "react";
import { makeStyles, createStyles, Button } from "@material-ui/core";
import classnames from "classnames";
import { ITheme } from "../Layout/themes";

const useStyles = makeStyles(({ palette, breakpoints }: ITheme) => {
  return createStyles({
    buttonGroup: {
      minWidth: 129,
      maxWidth: 140,
      flexShrink: 0,
      border: "1px solid #00497a",
      borderRadius: '4px',
      display: "flex",
      margin: "0 10px 10px 0"
    },
    btn: {
      width: 70,
      height: 38,
      flexGrow: 1,
      fontSize: 14,
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: 0,
      border: "none",
      [breakpoints.down("sm")]: {
        width: "auto",
        fontSize: 12
      }
    }
  });
});

export interface IOption {
  label: string;
  value: string;
  defaultSelected?: boolean;
}

interface IProps {
  options: IOption[];
  handleToggle: (optionValue: string) => void;
}

const ButtonTogglerComponent = ({ options, handleToggle }: IProps) => {
  const classes = useStyles({});

  const [selected, setSelected] = useState(options[0]);

  return (
    <div className={classes.buttonGroup}>
      {options.map((option, index) => (
        <Button
          key={index}
          className={classnames(classes.btn)}
          data-testid={selected.value === option.value && "selected"}
          variant={selected.value === option.value ? "contained" : "outlined"}
          onClick={() => {
            setSelected(() => option);
            handleToggle(option.value);
          }}
          color="primary"
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};

export const ButtonToggler = ButtonTogglerComponent;
